import type { FC, SVGProps } from 'react'
import { At } from '@components/Icons/Flags/At'
import { Be } from '@components/Icons/Flags/Be'
import { Br } from '@components/Icons/Flags/Br'
import { Ch } from '@components/Icons/Flags/Ch'
import { De } from '@components/Icons/Flags/De'
import { Es } from '@components/Icons/Flags/Es'
import { Eu } from '@components/Icons/Flags/Eu'
import { Fr } from '@components/Icons/Flags/Fr'
import { Gb } from '@components/Icons/Flags/Gb'
import { It } from '@components/Icons/Flags/It'
import { Us } from '@components/Icons/Flags/Us'
export const brazilUrl = 'https://n26brasil.com/'

export type CountryCodes = keyof typeof COUNTRIES_DETAILS

export type UrlsPerCountry = Record<CountryCodes, string[]>

export const DEFAULT_COUNTRY = 'eu'

type CountryDefaultNames =
  | 'Deuschland'
  | 'Europe'
  | 'Italia'
  | 'España'
  | 'France'
  | 'Brasil'
  | 'United States'
  | 'Österreich'
  | 'United Kingdom'
  | 'Schweiz'
  | 'Belgique'

type CountryAltNames =
  | 'Germany'
  | 'Europe'
  | 'Italy'
  | 'Spain'
  | 'France'
  | 'Brazil'
  | 'United States'
  | 'Austria'
  | 'United Kingdom'
  | 'Switzerland'
  | 'Belgium'

export type CountryNames = CountryAltNames | CountryDefaultNames

export type DefaultLanguages =
  | 'English'
  | 'Deutsch'
  | 'Italiano'
  | 'Español'
  | 'Français'
  | 'Português'

type AltLanguages =
  | 'English'
  | 'German'
  | 'Italian'
  | 'Spanish'
  | 'French'
  | 'Portuguese'

export type Languages = DefaultLanguages | AltLanguages

export const LANGUAGE_CODES = ['de', 'it', 'fr', 'en', 'es'] as const

export type LanguageCodes = (typeof LANGUAGE_CODES)[number]

export interface SVGComponentProps extends SVGProps<SVGSVGElement> {
  testId?: string
}

export type FlagIcon = FC<SVGComponentProps>
export type Icon = FC<SVGComponentProps>

export const COUNTRIES_DETAILS = {
  es: { defaultLang: 'es', FlagIcon: Es, enabled: true },
  de: { defaultLang: 'de', FlagIcon: De, enabled: true },
  fr: { defaultLang: 'fr', FlagIcon: Fr, enabled: true },
  it: { defaultLang: 'it', FlagIcon: It, enabled: true },
  at: { defaultLang: 'de', FlagIcon: At, enabled: true },
  ch: { defaultLang: 'de', FlagIcon: Ch, enabled: true },
  us: { defaultLang: 'en', FlagIcon: Us, enabled: false },
  gb: { defaultLang: 'en', FlagIcon: Gb, enabled: false },
  br: { defaultLang: 'en', FlagIcon: Br, enabled: false },
  eu: { defaultLang: 'en', FlagIcon: Eu, enabled: true },
  be: { defaultLang: 'fr', FlagIcon: Be, enabled: true },
} as const

export const ENABLED_COUNTRY_CODES = Object.keys(COUNTRIES_DETAILS)
  .filter(
    (country: string) =>
      COUNTRIES_DETAILS[country as keyof typeof COUNTRIES_DETAILS].enabled
  )
  .map((country: string) => country.toUpperCase(), [])

export const COUNTRY_CODE_VALUES = Object.keys(COUNTRIES_DETAILS).map(
  country => country.toUpperCase(),
  []
)

export type COUNTRY_CODES = Uppercase<keyof typeof COUNTRIES_DETAILS>

export const TOTAL_COUNTRIES = COUNTRY_CODE_VALUES.length

export const LANGUAGE_LABELS = {
  en: 'languageNameEnglish',
  es: 'languageNameSpanish',
  de: 'languageNameGerman',
  fr: 'languageNameFrench',
  it: 'languageNameItalian',
}

export const COUNTRIES_LABELS = {
  es: 'countryNameSpain',
  de: 'countryNameGermany',
  fr: 'countryNameFrance',
  it: 'countryNameItaly',
  at: 'countryNameAustria',
  ch: 'countryNameSwitzerland',
  us: 'countryNameUnitedStates',
  gb: 'countryNameUnitedKingdom',
  br: 'countryNameBrasil',
  eu: 'countryNameEurope',
  be: 'countryNameBelgium',
}

export const WAIT_LIST_COUNTRIES = [] as const
